<button
    matButton="filled"
    color="primary"
    (click)="goToCart()"
    [disabled]="!cartBill.cartBillResponseDTOList.length"
    id="continue-button"
>
    <ng-content />
</button>
